<div
  class="ui visible message"
  *ngIf="!filtersArray.length"
>
  You have not added any filters yet. Click on the plus (+) button below to start adding filters.
</div>
<div
  class="wrapper"
  *ngFor="let arr of filtersArray; let i = index; let isLastBlock = last; trackBy: trackByFiltersArray"
>
  <div
    class="ui grid container container__filter"
    [ngClass]="{ 'container__filter--last': isLastFilter && isLastBlock }"
    *ngFor="
      let filter of arr.expressions;
      let j = index;
      let isLastFilter = last;
      trackBy: trackByFiltersExpressions.bind(this, i)
    "
  >
    <div
      class="four wide column dropdown"
      [class.disabled]="readonly"
    >
      <dropdown
        [ngModel]="findFilterSource(filter)"
        (modelChange)="changeFilterSource($event, i, j, true)"
        [options]="filterSourceList"
        [editableOptions]="editableFilterSources"
        [settings]="dropdownSingleSettings"
        class="fluid search selection"
        [class.error]="filterSourceWarnings[i][j]"
        (click)="onFilterSourceDropdown(i, j)"
      ></dropdown>
      <div
        *ngIf="filterSourceWarnings[i][j]"
        class="warning"
      >
        <span class="warning__text">Incompatible dimension</span>
        <span
          class="ui tooltip"
          [attr.data-tooltip]="
            'This dimension is not compatible with one or more selected dimensions or global filters. Change or remove the dimension/filter to resolve this.'
          "
          data-position="right center"
          data-inverted=""
        >
          <i class="question circle icon"></i>
        </span>
      </div>
    </div>

    <div
      [class.disabled]="!filter.isSearchable || readonly || !options.showMultipleOptions"
      class="four wide column dropdown"
    >
      <dropdown
        [ngModel]="findQueryFilterOption(filter.type)"
        placeholder="Select Filter"
        (modelChange)="changeFilterType($event, i, j, !isDateDimension(filter))"
        [options]="filterOptions"
        [editableOptions]="editableFilterOptions[i][j]"
        [settings]="dropdownSingleSettings"
        class="fluid search selection"
      ></dropdown>
    </div>
    <div
      [class.disabled]="!filter.isSearchable || readonly"
      class="five wide column dropdown"
    >
      <p-multiSelect
        *ngIf="queryFilterSelection[i][j] === 'any' || queryFilterSelection[i][j] === 'not_any'"
        [styleClass]="emptyFilterValueWarnings[i][j] ? 'tw-min-w-full tw-bg-yellow-100' : 'tw-min-w-full'"
        [panelStyle]="{ 'max-width': '25rem' }"
        optionLabel="value"
        display="chip"
        placeholder="Select Values"
        appendTo="body"
        [filter]="true"
        [loadingIcon]="' fa-solid fa-circle-notch fa-spin'"
        [options]="matches[filter.key]"
        [loading]="matches[filter.key]?.length ? false : loading[i][j]"
        [(ngModel)]="filter.values"
        (onChange)="onValueChange($event.value, i, j)"
        (onClick)="multiSelectDropdownClick(filter, i, j)"
        (onPanelShow)="focusSearch()"
      >
        <ng-template
          pTemplate="filter"
          let-value
          let-options="options"
        >
          <div class="tw-flex tw-items-center tw-w-full tw-mb-2">
            <p-iconField class="tw-w-full">
              <input
                #filterInput
                pInputText
                type="text"
                class="tw-w-full"
                (input)="onFilterInputChange(filterInput.value, filter, i, j)"
              />
              <p-inputIcon>
                <i class="tw-leading-4 tw-align-middle tw-mb-3 fa-solid fa-magnifying-glass"></i>
              </p-inputIcon>
            </p-iconField>
          </div>
        </ng-template>

        <ng-template
          let-selectedItems
          pTemplate="selectedItems"
        >
          <div class="selected-items">
            <p-chip
              *ngFor="let item of selectedItems"
              styleClass="tw-my-1 tw-text-sm tw-flex tw-gap-1 tw-justify-between"
              [removable]="true"
              (onRemove)="removeSelectedFilterValue($event, item, i, j)"
            >
              <div class="tw-w-36 tw-break-words">
                <span class="tw-font-semibold">{{ item.value }}</span>
                <span
                  *ngIf="item.slice"
                  class="tw-ml-1"
                >
                  ({{ item.slice }})
                </span>
              </div>
            </p-chip>
          </div>
        </ng-template>
        <ng-template
          let-dimension
          pTemplate="item"
        >
          <div>
            <span class="tw-font-semibold">{{ dimension.value }}</span>
            <span
              *ngIf="dimension.slice"
              class="tw-ml-1"
            >
              ({{ dimension.slice }})
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="empty">
          <div class="tw-p-2 tw-text-gray-500">
            {{ loading[i][j] ? 'Searching...' : 'No results found' }}
          </div>
        </ng-template>
      </p-multiSelect>

      @if (chipFilterOperators.includes(queryFilterSelection[i][j]) && !isDateDimension(filter)) {
      <p-autoComplete
        [ngModel]="filter.values"
        class="tw-break-words"
        multiple
        [typeahead]="false"
        [addOnBlur]="true"
        [addOnTab]="true"
        [unique]="true"
        placeholder="Add value(s)..."
        [disabled]="!filter.type"
        [styleClass]="emptyFilterValueWarnings[i][j] ? 'tw-w-full tw-bg-yellow-100' : 'tw-w-full'"
        [class.filter--max-values]="isMaxFilterValuesReached(filter)"
        (ngModelChange)="onChipValuesChange($event, i, j)"
      ></p-autoComplete>
      @if (isMaxFilterValuesReached(filter)) {
      <div class="tw-pt-1 tw-text-xs tw-text-gray-500">Maximum amount ({{ maxFilterValues }}) of items added</div>
      } } @else if (!chipFilterOperators.includes(queryFilterSelection[i][j]) && queryFilterSelection[i][j] !== 'any' &&
      queryFilterSelection[i][j] !== 'not_any' && queryFilterSelection[i][j] !== 'na' && queryFilterSelection[i][j] !==
      'not_na' && !isDateDimension(filter)) {
      <div
        class="ui input fluid"
        [class.warn]="emptyFilterValueWarnings[i][j]"
      >
        <input
          type="text"
          placeholder="Value..."
          [disabled]="!filter.type"
          [(ngModel)]="filter.values"
          (ngModelChange)="onValueChange($event, i, j)"
          [class.error]="emptyFilterValueWarnings[i][j] && !filter.values"
        />
      </div>
      }
      <div
        class="tw-flex tw-gap-2 tw-items-center tw-flex-col"
        [class.warn]="emptyFilterValueWarnings[i][j]"
        *ngIf="isDateDimension(filter)"
      >
        <p-selectButton
          *ngIf="
            supportRelativeDates && queryFilterSelection[i][j] !== 'is_in' && queryFilterSelection[i][j] !== 'not_is_in'
          "
          [options]="dateTypeOptions"
          [(ngModel)]="selectedDateTypes[i][j]"
          (onChange)="onValueChange(null, i, j)"
          [allowEmpty]="false"
          optionValue="value"
        >
          <ng-template
            let-item
            pTemplate="item"
          >
            <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-z-20">
              <i [class]="item.icon"></i>
              {{ item.label }}
            </div>
          </ng-template>
        </p-selectButton>
        <div
          *ngIf="queryFilterSelection[i][j] !== 'is_in' && queryFilterSelection[i][j] !== 'not_is_in'"
          class="tw-w-full tw-text-center"
        >
          <ng-container *ngIf="selectedDateTypes[i][j] === 'static' || !supportRelativeDates; else dynamicDate">
            <p-datepicker
              [ngModel]="getDateValue(filter, i, j)"
              [showIcon]="true"
              [iconDisplay]="'input'"
              [disabled]="!filter.type"
              (onSelect)="onValueChange($event, i, j)"
              (onClear)="onValueChange(null, i, j)"
              (onClearClick)="onValueChange(null, i, j)"
              [class.error]="emptyFilterValueWarnings[i][j] && !filter.values"
              dateFormat="yy-mm-dd"
              [showButtonBar]="true"
              [showOnFocus]="true"
              [placeholder]="'Select date...'"
              appendTo="body"
            ></p-datepicker>
          </ng-container>
          <ng-template #dynamicDate>
            <div class="tw-flex tw-w-full tw-gap-2 tw-items-center tw-justify-center">
              <p-inputNumber
                [min]="0"
                [max]="999"
                class="overflow-hidden"
                [showButtons]="true"
                inputStyleClass="tw-w-[5em]"
                [inputStyle]="{ minWidth: 'calc(5ch + var(--p-form-field-padding-x)*2 + 1.875rem)' }"
                [class.warn]="emptyFilterValueWarnings[i][j]"
                [ngModel]="getDateValue(filter, i, j)?.num"
                (onInput)="onDynamicDateChange({ num: $event.value }, i, j)"
                [class.error]="emptyFilterValueWarnings[i][j] && !filter.values"
              ></p-inputNumber>
              <span>days</span>
              <p-select
                panelStyleClass="tw-w-36"
                [options]="dynamicDateDirectionOptions"
                [ngModel]="getDateValue(filter, i, j)?.direction || 'ago'"
                (onChange)="onDynamicDateChange({ direction: $event.value }, i, j)"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
              ></p-select>
            </div>
          </ng-template>
        </div>
        <div
          *ngIf="queryFilterSelection[i][j] === 'is_in' || queryFilterSelection[i][j] === 'not_is_in'"
          class="tw-w-full"
        >
          <div class="tw-flex tw-w-full tw-gap-2 tw-items-center tw-justify-center">
            <p-select
              styleClass="tw-w-full"
              panelStyleClass="tw-w-36"
              [options]="dateRangeRelationOptions"
              [ngModel]="getDateValue(filter, i, j)?.relation || 'last'"
              (onChange)="onDynamicDateRangeChange({ relation: $event.value }, i, j)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            ></p-select>
            <p-select
              styleClass="tw-w-full"
              panelStyleClass="tw-w-36"
              [options]="dateRangeUnitOptions"
              [ngModel]="getDateValue(filter, i, j)?.unit || 'week'"
              (onChange)="onDynamicDateRangeChange({ unit: $event.value }, i, j)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            ></p-select>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          emptyFilterValueWarnings[i][j] &&
          queryFilterSelection[i][j] !== 'na' &&
          queryFilterSelection[i][j] !== 'not_na'
        "
        class="warning"
        [ngClass]="{ 'tw-text-center': isDateDimension(filter) }"
      >
        <span class="warning__text">Value missing</span>
        <span
          class="ui tooltip"
          [attr.data-tooltip]="
            'The query will ignore an empty filter line. Please select a value from the dropdown menu or add text input to include it in the query.'
          "
          data-position="right center"
          data-inverted=""
        >
          <i class="question circle icon"></i>
        </span>
      </div>
    </div>
    <div
      class="three wide column"
      *ngIf="!readonly"
    >
      <div class="buttons-group">
        <ng-container *ngIf="options.showOrFilters">
          <p-button
            [icon]="isLastFilter ? 'fa fa-plus' : null"
            [label]="innerConnective.toUpperCase()"
            size="large"
            severity="secondary"
            class="button--or notHide"
            styleClass="tw-shrink-0"
            (click)="addFilter(i, j)"
            [disabled]="!isLastFilter"
          ></p-button>
        </ng-container>
        <p-button
          icon="fa fa-xmark"
          class="button--remove notHide tw-align-middle"
          severity="secondary"
          [rounded]="true"
          (click)="removeFilter(i, j)"
        ></p-button>
      </div>
    </div>
    <div
      class="three wide column"
      *ngIf="readonly && !isLastFilter"
    >
      <div class="buttons-group">
        <p-button
          class="connective-static connective-static--inner"
          [label]="innerConnective.toUpperCase()"
          severity="secondary"
          [disabled]="true"
        ></p-button>
      </div>
    </div>
  </div>
  <div
    class="ui grid container button--and notHide"
    *ngIf="!isLastBlock"
  >
    <p-selectButton
      *ngIf="!readonly; else staticConnective"
      class="connective-toggle connective-toggle--top"
      [options]="connectiveOptions"
      [ngModel]="connective"
      (onChange)="setTopConnective($event.value)"
      [allowEmpty]="false"
      optionValue="value"
    ></p-selectButton>
    <ng-template #staticConnective>
      <p-button
        class="connective-static connective-static--top"
        [label]="connective.toUpperCase()"
        severity="secondary"
        [disabled]="true"
      ></p-button>
    </ng-template>
  </div>
</div>

<p-button
  icon="fa fa-plus"
  rounded="true"
  severity="secondary"
  (click)="addBlock()"
  *ngIf="!readonly"
></p-button>
